document.addEventListener('DOMContentLoaded', initCompreJuntoAccordion);
document.addEventListener('shopify:section:load', initCompreJuntoAccordion);

function initCompreJuntoAccordion() {
  const triggers = document.querySelectorAll('.compre-junto__trigger');

  triggers.forEach((trigger) => {
    if (trigger.dataset.bound === 'true') return;
    trigger.dataset.bound = 'true';

    trigger.setAttribute('type', 'button');

    const contentId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    if (!content) return;

    const icon = trigger.querySelector('.compre-junto__icon');
    const isOpen = trigger.classList.contains('is-open');

    if (isOpen) {
      content.style.height = 'auto';
      trigger.setAttribute('aria-expanded', 'true');
      if (icon) icon.textContent = '−';
    } else {
      content.style.height = '0px';
      trigger.setAttribute('aria-expanded', 'false');
      if (icon) icon.textContent = '+';
    }

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const opened = trigger.classList.contains('is-open');

      if (opened) {
        const currentHeight = content.scrollHeight;
        content.style.height = `${currentHeight}px`;

        requestAnimationFrame(() => {
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          content.style.height = '0px';
          if (icon) icon.textContent = '+';
        });

        return;
      }

      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      content.style.height = `${content.scrollHeight}px`;
      if (icon) icon.textContent = '−';

      const onEnd = () => {
        if (trigger.classList.contains('is-open')) {
          content.style.height = 'auto';
        }
        content.removeEventListener('transitionend', onEnd);
      };

      content.addEventListener('transitionend', onEnd);
    });
  });
}